// Measure the editable header so the full-bleed hero copy stays below navigation.
(() => {
  const setup = () => {
    if (!document.body.classList.contains('lm-home')) return;
    const header = document.querySelector('.section-header');
    const announcement = document.querySelector('.announcement-bar-section');
    if (!header) return;
    const measure = () => {
      const announcementHeight = announcement?.offsetHeight || 0;
      document.documentElement.style.setProperty('--lm-announcement-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--lm-header-offset', `${announcementHeight + header.offsetHeight}px`);
    };
    measure();
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    if (announcement) observer.observe(announcement);
    document.addEventListener('shopify:section:unload', () => observer.disconnect(), {once:true});
  };
  setup();
  document.addEventListener('shopify:section:load', setup);
})();
